import {
  IPayerNameList,
  IPayerAddressList,
  IHealthPlanTypeList,
  IScenariosList,
  IUnmappedHealthPlanNameList,
} from '../Infrastructure/Interfaces';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { act } from 'react';

const healthPlansNotMappedInitialState: IUnmappedHealthPlanNameList = {
  loading: true,
  unmappedHealthPlanList: [],
};

const payerNameListInitialState: IPayerNameList = {
  loading: true,
  payerNameList: [],
};

const payerAddressListInitialState: IPayerAddressList = {
  loading: true,
  payerAddressList: [],
};

const healthPlanTypeListInitialState: IHealthPlanTypeList = {
  loading: true,
  healthPlanTypeList: [],
};

const scenariosListInitialState: IScenariosList = {
  loading: true,
  scenariosList: [],
};

export const fetchUnmappedHealthPlansList = createAsyncThunk(
  'fetchUnmappedHealthPlansList',
  async (region: string) => {
    const baseurl = process.env.REACT_APP_SERVER_BASE_URL as string;
    const tokenurl = process.env.REACT_APP_TOKEN_URL_SIS as string;

    return axios.get(tokenurl).then(res => {
      if (res.data.success) {
        return axios
          .get(baseurl + '/Payer/get_healthplanname_not_mapped' + '?region=' + region, {
            headers: {
              Pragma: 'no-cache',
              Authorization: 'Bearer ' + res.data.token,
            },
          })
          .then(response => {
            if (response.data.success) {
              return response.data.result;
            }
          });
      }
    });
  }
);

const UnmappedHealthPlanNamesListSlice = createSlice({
  name: 'healthplanmapping',
  initialState: healthPlansNotMappedInitialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchUnmappedHealthPlansList.fulfilled, (state, action) => {
      state.loading = false;
      state.unmappedHealthPlanList = action.payload;
    });
    builder.addCase(fetchUnmappedHealthPlansList.rejected, (state, action) => {
      state.loading = false;
      state.unmappedHealthPlanList = [];
    });
    builder.addCase(fetchUnmappedHealthPlansList.pending, (state, action) => {
      state.loading = true;
    });
  },
});

export const fetchPayerAddressList = createAsyncThunk(
  'fetchPayerAddressList',
  async () => {
    const baseurl = process.env.REACT_APP_RRD_OPTIMIZATION_BASE_URL as string;
    //const tokenurl = process.env.REACT_APP_TOKEN_URL_SIS as string;

            return axios
              .get(baseurl + '/Payer/get_PayerAddressList', {
                headers: {
                    Pragma: 'no-cache'
            },
          })
          .then(response => {
            if (response.data.success) {
              return response.data.result;
            }
          });
      }
);

const PayerAddressListSlice = createSlice({
  name: 'payeraddresslist',
  initialState: payerAddressListInitialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchPayerAddressList.fulfilled, (state, action) => {
      state.loading = false;
      state.payerAddressList = action.payload;
    });
    builder.addCase(fetchPayerAddressList.rejected, (state, action) => {
      state.loading = true;
      state.payerAddressList = [];
    });
    builder.addCase(fetchPayerAddressList.pending, (state, action) => {
      state.loading = true;
    });
  },
});

export const fetchHealthPlanTypeList = createAsyncThunk(
  'fetchHealthPlanTypeList',
  async () => {
    const baseurl = process.env.REACT_APP_SERVER_BASE_URL as string;
    const tokenurl = process.env.REACT_APP_TOKEN_URL_SIS as string;

    return axios.get(tokenurl).then(res => {
      if (res.data.success) {
        return axios
          .get(baseurl + '/Payer/get_allhealthplantype_list', {
            headers: {
              Pragma: 'no-cache',
              Authorization: 'Bearer ' + res.data.token,
            },
          })
          .then(response => {
            if (response.data.success) {
              return response.data.result;
            }
          });
      }
    });
  }
);

const HealthPlanTypeListSlice = createSlice({
  name: 'healthplantype',
  initialState: healthPlanTypeListInitialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchHealthPlanTypeList.fulfilled, (state, action) => {
      state.loading = false;
      state.healthPlanTypeList = action.payload;
    });
    builder.addCase(fetchHealthPlanTypeList.rejected, (state, action) => {
      state.loading = false;
      state.healthPlanTypeList = [];
    });
    builder.addCase(fetchHealthPlanTypeList.pending, (state, action) => {
      state.loading = true;
    });
  },
});

export const fetchSceneriosList = createAsyncThunk(
  'fetchSceneriosList',
  async () => {
    const scenariosbaseurl = process.env.REACT_APP_SERVER_SCENARIOS_BASE_URL as string;
    const scenariostokenurl = process.env.REACT_APP_SCENARIO_TOKEN_URL as string;

    return axios.get(scenariostokenurl).then(res => {
      if (res.data.success) {
        return axios
          .get(scenariosbaseurl + '/Appeal/get_scenarios', {
            headers: {
              Pragma: 'no-cache',
              Authorization: 'Bearer ' + res.data.token,
            },
          })
          .then(response => {
            if (response.data.success) {
              return response.data.result;
            }
          });
      }
    });
  }
);

const ScenariosListSlice = createSlice({
  name: 'getscenarios',
  initialState: scenariosListInitialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchSceneriosList.fulfilled, (state, action) => {
      state.loading = false;
      state.scenariosList = action.payload;
    });
    builder.addCase(fetchSceneriosList.rejected, (state, action) => {
      state.loading = false;
      state.scenariosList = [];
    });
    builder.addCase(fetchSceneriosList.pending, (state, action) => {
      state.loading = true;
    });
  },
});


export const UnmappedHealthPlanNamesReducer = UnmappedHealthPlanNamesListSlice.reducer;
export const PayerAddressListReducer = PayerAddressListSlice.reducer;
export const HealthPlanTypeListReducer = HealthPlanTypeListSlice.reducer;
export const ScenariosListReducer = ScenariosListSlice.reducer;
